import * as React from 'react';
const { useCallback, useRef } = React;
import Typography from '@seeneco-ui/core/components/typography';
import Button from '@seeneco-ui/core/components/button';
import ActionScreen from '@seeneco-ui/core/components/action-screen';
import Box from '@seeneco-ui/core/components/box';
import { Form, FormTextField, FormRef } from '@seeneco-ui/core/components/form';
import Spinner from '@seeneco-ui/core/components/spinner';
import FormHelpers from '@seeneco-ui/core/components/form-helpers';

import {
	FormLayout,
} from './styled';


type ContactDataProps = {
	isFetching: boolean;
	tenant: Tenant;
	onUpdateTenant: (tenant: Tenant) => void;
};

const ContactData: React.SFC<ContactDataProps> = (props) => {
	const {
		isFetching,
		tenant,
		onUpdateTenant,
	} = props;
	const formRef = useRef<FormRef>(null);
	const handleSave = useCallback(() => formRef.current && formRef.current.submitForm(), [formRef.current]);
	const handleReset = useCallback(() =>  formRef.current && formRef.current.resetForm(), [formRef.current]);
	const handleUpdateTenant = useCallback((formObject: Tenant) => onUpdateTenant(formObject), []);

	const renderForm = () => {
		return (
			<Form
				ref={formRef as React.LegacyRef<any>}
				formObject={tenant}
				isFetching={isFetching}
				onSubmit={handleUpdateTenant}>
				<Box width='100%' marginBottom='20px'>
					<FormHelpers.FormLabel>
						Номер личного кабинета
					</FormHelpers.FormLabel>
					<Box marginTop='10px'>
						<Typography.Text fontWeight={700}># {tenant && tenant.StorageID}</Typography.Text>
					</Box>
				</Box>
				<FormTextField
					name='Name'
					label='Наименование личного кабинета'
					placeholder='ООО «Ромашка»'
					fullWidth
					required
				/>
				<FormTextField
					name='ContactEMail'
					label='E-mail'
					placeholder='mail@example.com'
					fullWidth
					required
				/>
				<FormTextField
					name='ContactPhoneNumber'
					label='Телефонный номер'
					placeholder='+7 (910) 123-45-67'
					fullWidth
					required
				/>
				<FormTextField
					name='ContactPersonName'
					label='Контактное лицо'
					placeholder='Например, Александр'
					fullWidth
					required
				/>
			</Form>
		);
	};

	return (
		<ActionScreen.Base
			renderHeader={(props) => (
				<ActionScreen.Header {...props}>
					<Typography.Title>Контактные данные</Typography.Title>
				</ActionScreen.Header>
			)}
			renderFooter={() => (
				<ActionScreen.Footer>
					<Button onClick={handleSave}>Сохранить</Button>
					<Button color='default' onClick={handleReset}>Отмена</Button>
				</ActionScreen.Footer>
			)}>
			{
				isFetching
				?	<Box
						width='100%'
						minHeight='300px'
						display='flex'
						justifyContent='center'
						alignItems='center'>
						<Spinner />
					</Box>
				: 
				<FormLayout>
					{renderForm()}
				</FormLayout>
			}
		</ActionScreen.Base>
	);
}

ContactData.displayName = 'ContactData';
ContactData.defaultProps = {};

export default ContactData;
